import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCallback, useState } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
export const NoWrapDiv = styled.div.withConfig({
  displayName: "TruncateDiv__NoWrapDiv",
  componentId: "sc-1mcr0y1-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

const TruncateDiv = ({
  rightAligned,
  children
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(UITooltipContent, {
    children: children
  }), [children]);
  return /*#__PURE__*/_jsx(UITooltip, {
    Content: TooltipContent,
    maxWidth: 500,
    disabled: !isTruncated,
    children: /*#__PURE__*/_jsx(NoWrapDiv, {
      className: rightAligned ? 'width-100 text-right' : '',
      onMouseEnter: handleMouseEnter,
      "data-test-id": "truncated-object-label",
      children: children
    })
  });
};

export default TruncateDiv;